<template>
  <div class="wrapper address-wrapper">
    <section class="section address-form">
      <div class="form-group">
        <label class="title">收货人</label>
        <input type="text" class="form-controls" v-model="form.name" />
      </div>
      <div class="form-group">
        <label class="title">联系电话</label>
        <input type="tel" class="form-controls" v-model="form.phone" />
      </div>
      <div class="form-group">
        <label class="title">所在地区</label>
        <div class="form-address" @click="showAddress">
          <template v-if="form.province && form.city">
            <p>{{form.province}} {{form.city}} {{form.district}}</p>
          </template>
          <span v-else>请选择</span>
        </div>
      </div>
      <div class="form-group">
        <label class="title">详细地址</label>
        <input type="text" class="form-controls" placeholder="街道、门牌号等" v-model="form.address" />
      </div>
    </section>
    <mt-popup v-model="popupVisible" position="bottom" class="popup-address">
      <div class="hd">
        <div class="aside" @click="onSubmitAddress">完成</div>
      </div>
      <mt-picker :slots="addressSlots" valueKey="name" @change="onAddressChange"></mt-picker>
    </mt-popup>
    <div class="btn-address" @click="onSbumit">保存</div>
  </div>
</template>
<script>
// 接口
import { getAddress } from '@/api/base'
import { addAddress, updateAddress, getAddressItem } from '@/api/address'

export default {
  name: 'AddressUpdate',
  metaInfo() {
    return { title: this.title }
  },
  data() {
    return {
      pid: '',
      title: '',
      form: {
        name: '',
        phone: null,
        provinceId: null,
        province: '',
        cityId: null,
        city: '',
        districtId: null,
        district: '',
        address: ''
      },
      addressList: [],
      addressSlots: [
        { flex: 1, defaultIndex: 0, values: [] },
        { flex: 1, defaultIndex: 0, values: [] },
        { flex: 1, defaultIndex: 0, values: [] }
      ],
      addressValues: [],
      popupVisible: false,
      disabled: false
    }
  },
  methods: {
    // 初始化
    init() {
      if (this.pid) {
        this.title = '编辑收货地址'
        this.getAddressItem()
      } else {
        this.title = '添加收货地址'
      }
      this.getAddress()
    },
    onSbumit() {
      if (!this.checkForm() || this.disabled) {
        return false
      }
      this.disabled = true
      if (!this.pid) {
        // 添加地址
        this.addAddress()
      } else {
        // 修改地址
        this.updateAddress()
      }
    },
    // 表单校验
    checkForm() {
      // 是否为手机号
      function isPhoneNumber(value) {
        if (/^[0-9]*$/g.test(value)) {
          return true
        } else {
          return false
        }
      }
      if (!this.form.name) {
        this.$toast('请填写收货人')
        return false
      }
      if (!this.form.phone) {
        this.$toast('请填写联系电话')
        return false
      }
      if (!isPhoneNumber(this.form.phone)) {
        this.$toast('请填写正确的联系电话')
        return false
      }
      if (!this.form.provinceId && !this.form.cityId && !this.form.districtId) {
        this.$toast('请选择地区')
        return false
      }
      if (!this.form.address) {
        this.$toast('请填写详细地址')
        return false
      }
      return true
    },
    // 添加地址
    addAddress() {
      addAddress(this.form)
        .then(response => {
          this.$router.go(-1)
          this.disabled = false
        })
        .catch(response => {
          this.disabled = false
        })
    },
    // 获取收货地址详情
    getAddressItem() {
      getAddressItem({ id: this.pid }).then(response => {
        Object.assign(this.form, response.data)
      })
    },
    // 修改地址
    updateAddress() {
      let params = Object.assign({}, this.form, { id: this.pid })
      updateAddress(params)
        .then(response => {
          this.$router.go(-1)
          this.disabled = false
        })
        .catch(response => {
          this.disabled = false
        })
    },
    // 获取省市区
    getAddress() {
      getAddress().then(response => {
        this.addressList = [...this.addressList, ...response]
        let results = this.getAddressSlots()
        this.addressSlots[0].values = results.province
      })
    },
    onAddressChange(picker, values) {
      let [province = {}, city = {}, area = {}] = values
      let provinceId = province.id || null
      let cityId = city.id || null
      let areaId = area.id || null
      // 市
      picker.setSlotValues(
        1,
        this.getAddressSlots(provinceId, cityId, areaId).city
      )
      // 区
      picker.setSlotValues(
        2,
        this.getAddressSlots(provinceId, cityId, areaId).area
      )
      this.addressValues = values
    },
    getAddressSlots(provinceId, cityId, areaId) {
      let results = { province: [], city: [], area: [] }
      this.addressList.forEach(province => {
        // 省
        provinceId = provinceId || this.addressList[0].provinceId
        results.province.push({
          id: province.provinceId,
          name: province.provinceName
        })
        // 市
        if (provinceId === province.provinceId) {
          province.city.forEach(city => {
            cityId = cityId || province.city[0].cityId
            results.city.push({ id: city.cityId, name: city.cityName })

            // 区
            if (cityId === city.cityId) {
              city.area.forEach(area => {
                results.area.push({ id: area.areaId, name: area.areaName })
              })
            }
          })
        }
      })
      return results
    },
    // 显示地址选择
    showAddress() {
      this.popupVisible = true
    },
    // 确认选择地址
    onSubmitAddress() {
      let [province, city, area = {}] = this.addressValues
      this.form.provinceId = province.id
      this.form.province = province.name
      this.form.cityId = city.id
      this.form.city = city.name
      this.form.districtId = area.id || ''
      this.form.district = area.name || ''
      this.popupVisible = false
    }
  },
  created() {
    this.pid = this.$route.params.id
    this.init()
  }
}
</script>
<style src='@/assets/css/address.css'></style>
